














import { defineComponent } from '@vue/composition-api';

export default defineComponent({
    name: 'SdsBreadcrumbsDropdownBoxToggle',
    emits: ['click'],
    setup(_, { emit }) {
        const handleClick = (event: MouseEvent) => {
            event.stopPropagation();

            emit('click');
        };

        return {
            handleClick,
        };
    },
});
